module.exports = __webpack_public_path__ + "static/media/Sochy.90287c31.svg";